export default "__VITE_ASSET__DI$4TajZ__"